import { v4 } from 'uuid';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { notification } from 'antd';
import {
  setNewScreeningCategoriesFiltersOptions,
  setNewScreeningData,
  setNewScreeningFilters,
  setNewScreeningLevelsFiltersOptions,
  setTestGroupsData,
  setScreenings,
  setAmountOfFilters,
  setNewScreeningRolesFiltersOptions,
  setCustomTestGroupIncompleteQuestion,
  setCustomTestGroupStrategy,
  setRecordingConfig,
  setNewScreeningQuickRolesOptions,
  setNewScreeningTagsFiltersOptions,
  setEndorsementCreatorsOptions,
  setEndorsementCompaniesOptions,
  setPromptCorrectionTextAI,
  updateNewScreeningProperty,
} from '../redux/actions/screeningActions';
import { t } from '../i18n/i18n';
import { formatOrder } from '../utils/formatArrayOrder';
import { Window } from '../utils/window';
import {
  getScreeningTestGroups,
  getTags,
  postScreening,
  getScreenings,
  getRolesWithTestGropusFilters,
  getCategoriesWithTestGroups,
  getQuickRolesWithTestGroups,
  getAIQuestionTrial,
  editRecruitSessionDraft,
  getEndorsements,
  getPrefilterQuesitons,
  deletePrefilterQuesiton,
  getRolesAll,
  getCategoriesAll,
  editPrefilterQuestion,
  getPromptCorrectionTextAI,
  getImageSignedUrl,
  getAudioSignedUrl,
  getPdfSignedUrl,
  uploadFileToS3,
  getAdditionalQuestions,
  searchAdditionalQuestions,
  deleteAdditionalQuestion,
  editAdditionalQuestion,
} from '../API/services/screeningService';
import processQueryString from '../utils/processQueryString';
import {
  AnswerTypeEnum,
  StrategyValues,
  SCREENING_SORT_STRATEGY,
  RecordingMode,
  CategoriesIdDefined,
  FilesType,
  MECHANOGRAFY_PPM_TEST,
  NPSProcessTypes,
  PromptSubTypes,
  ReviewTypeEnum,
  TestEditionAction,
  TestFileType,
  TestGroupTypes,
} from '../constants/enums';
import { TrackEventGTM } from '../utils/filters/analyticsUtils';
import { sortArrayAlphabeticallyByPropertyName } from '../utils/arrayUtils';
import { getLocalStorageWorkspace } from '../utils/workspaceUtils';
import { convertMinToMinutesNumber } from '../constants/hours';
import { getVideosForCompany } from '../API/services/authService';
import { useDeepCompareEffect } from '../utils/objectUtils';
import { setModalTestSuggestionAI } from '../redux/actions/evaluationActions';
import {
  getCustomTestGroupScreeningStrategy,
  getTestGroupScreeningStrategy,
  isAiInterviewStrategy,
} from '../utils/testgroups';
import { getPromptSubTypeByCurrentTypeQuestion } from '../utils/prompts';
import { canReadPDF } from '../utils/fileToObject';
import { setNPSProcessType } from '../redux/actions/npsActions';
import { TESTS } from '../constants/routes';
import { EventsGTM } from '../constants/events';

const useCreateScreening = () => {
  const dispatch = useDispatch();
  const { evaluation, modalTestSuggestionAI } = useSelector((state) => state.evaluation);
  const { search, pathname } = useLocation();
  const queryData = processQueryString(search);
  const [loading, setLoading] = useState(false);
  const [loadingAIAnswer, setLoadingAIAnswer] = useState(false);
  const {
    newScreening,
    newScreeningFilters,
    testGroupLevelsFilterOptions,
    testGroupCategoriesFilterOptions,
    testGroupRolesFilterOptions,
    testGroupTagsFilterOptions,
    endorsementCreatorsOptions,
    endorsementCompaniesOptions,
    testGroupQuickRolesOptions,
    testGroups,
    amountOfFilters,
    customTestGroupIncompleteQuestion,
    promptsCorrectionTextAI,
    customTestGroupStrategy,
    recordingConfig,
  } = useSelector((state) => state.screenings);
  const { user, currentWorkspace } = useSelector((state) => state.auth);
  const [localAvailableWeight, setLocalAvailableWeigth] = useState(100);
  const [testAnswer, setTestAnswer] = useState({
    text: '',
    score: undefined,
    explanation: undefined,
  });

  const existingCustomTestGroup = newScreening?.allTests?.find(
    (item) => item.type === TestGroupTypes.CUSTOM
  );
  const existingChallengeTestGroup = newScreening?.allTests?.find(
    (item) => item.type === TestGroupTypes.CHALLENGE_ASYNC_AI
  );
  const testsDuration = newScreening?.testGroups.reduce((acum, test) => {
    if (
      test.selectedPresetId !== undefined &&
      test.advancedSetting?.available &&
      test.advancedSetting?.preSettings?.length > 0
    ) {
      const selectedPreset = test.advancedSetting.preSettings.find(
        (preset) => String(preset.id) === String(test.selectedPresetId)
      );

      // Si encontramos el preset, calcular duración basada en sus configuraciones
      if (selectedPreset?.difficultyConfig) {
        const presetDuration = selectedPreset.difficultyConfig.reduce(
          (sum, config) => sum + config.quantity * config.duration,
          0
        );
        return acum + Math.round(presetDuration);
      }
    }

    // Si no tiene preset o no se encuentra, usar duración por defecto del testgroup
    return acum + Math.round(test.duration ?? 0);
  }, 0);
  const maxBytesFile = 1000000;
  const defaultCurrenQuestionData = { text: '' };
  const defaultDrawState = [
    {
      correct: false,
      text: 'drawFile',
      formula: '',
      files: [],
    },
  ];
  const defaultCheckState = [
    {
      correct: false,
      text: '',
      formula: '',
      files: [],
    },
    {
      correct: false,
      text: '',
      formula: '',
      files: [],
    },
  ];
  const defaultCodeOutputState = [
    {
      input: '',
      output: '',
    },
    {
      input: '',
      output: '',
    },
  ];
  const [welcomeVideos, setWelcomeVideos] = useState([]);

  const customTestGroupTotalTime =
    (newScreening.customTestGroupDuration.hours
      ? Number(newScreening.customTestGroupDuration.hours)
      : 0) *
      60 +
    (newScreening.customTestGroupDuration.minutes
      ? Number(newScreening.customTestGroupDuration.minutes)
      : 0) +
    (newScreening.customTestGroupDuration.seconds
      ? Number(newScreening.customTestGroupDuration.seconds)
      : 0) /
      60;

  const customScreeningTotalTime = convertMinToMinutesNumber(
    newScreening?.customScreeningTGDuration
  );

  const uploadAndUpdateFile = async (file) => {
    if (!TestFileType[file.fileType]) return;
    let signedUrl;
    if (file.fileType === TestFileType.IMAGE)
      signedUrl = await getImageSignedUrl(file.fileObject.type);
    if (file.fileType === TestFileType.AUDIO)
      signedUrl = await getAudioSignedUrl(file.fileObject.type);
    if (file.fileType === TestFileType.PDF) signedUrl = await getPdfSignedUrl(file.fileObject.type);

    await uploadFileToS3(signedUrl.fileUrl, file.fileObject, file.fileObject.type);

    file.displayName = file.name;
    file.name = signedUrl.fileId;
    file.extension = signedUrl.fileExtension;
    file.url = removeQueryParams(signedUrl.fileUrl);
    delete file.fileObject;
  };

  const uploadAndUpdateFiles = async (tests) => {
    const testsPromises = tests?.flatMap(
      (test) =>
        test.testFiles
          ?.filter((file) => file.fileObject)
          .map((file) => uploadAndUpdateFile(file)) ?? []
    );

    const optionsPromises =
      tests.flatMap((test) =>
        test.options
          ?.filter((option) => option.files?.length)
          .flatMap((option) => option.files)
          .filter((file) => file.fileObject)
          .map((file) => uploadAndUpdateFile(file))
      ) ?? [];

    const promises = [...testsPromises, ...optionsPromises];

    await Promise.all(promises);
  };

  const incompleteQuestionValidation =
    (newScreening?.currentQuestionData && newScreening?.currentQuestionData?.text?.length) ||
    newScreening?.currentQuestionData?.maxChar ||
    newScreening?.currentQuestionData?.fileTypes?.length ||
    newScreening?.currentQuestionData?.options?.some(
      (option) => Boolean(option?.text?.length) || option?.correct
    ) ||
    (newScreening?.currentTypeQuestion === AnswerTypeEnum.VIDEO_AI &&
      (newScreening?.currentQuestionData?.preparationTime ||
        newScreening?.currentQuestionData?.totalTime ||
        newScreening?.currentQuestionData?.maxAttempts));

  const incompletePrefilterQuestionValidation =
    newScreening?.prefilterQuestions &&
    newScreening.prefilterQuestions.length > 0 &&
    Number.isNaN(+newScreening.prefilterQuestionsDelay);

  const calculateAvailableWeight = (screening) =>
    screening?.allTests?.every(
      (testGroup) =>
        testGroup.type === TestGroupTypes.QUALITATIVE ||
        (testGroup.type === TestGroupTypes.CUSTOM &&
          !testGroup.tests?.some((test) =>
            [
              AnswerTypeEnum.CHECK,
              AnswerTypeEnum.TEXT_AI,
              AnswerTypeEnum.CODE_AI,
              AnswerTypeEnum.WRITE,
            ].includes(test.answerType)
          ))
    )
      ? 0
      : screening?.allTests?.reduce((acc, current) => acc - (current.weight ?? 0), 100);

  useDeepCompareEffect(() => {
    if (customTestGroupIncompleteQuestion && !incompleteQuestionValidation) {
      dispatch(setCustomTestGroupIncompleteQuestion(false));
    }
    if (![AnswerTypeEnum.CHECK, AnswerTypeEnum.RADIO].includes(newScreening?.currentTypeQuestion)) {
      setEachScoreValue(false);
    }
  }, [newScreening?.currentQuestionData]);

  useEffect(() => {
    if (existingCustomTestGroup) {
      existingCustomTestGroup.duration = Math.max(
        0,
        customTestGroupTotalTime || customScreeningTotalTime
      );
    }
  }, [newScreening?.customTestGroupDuration, newScreening?.customScreeningTGDuration]);

  useEffect(() => {
    if (newScreening?.allTests.length) {
      setLocalAvailableWeigth(calculateAvailableWeight(newScreening));
    }
    if (existingCustomTestGroup && !existingCustomTestGroup?.tests?.length) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          availableWeight: localAvailableWeight,
          allTests: formatOrder(
            newScreening?.allTests.filter(
              (item) =>
                item.type !== TestGroupTypes.CUSTOM &&
                item.type !== TestGroupTypes.CHALLENGE_ASYNC_AI
            )
          ),
          customTestGroupDuration: {
            hours: undefined,
            minutes: undefined,
            seconds: undefined,
          },
          customScreeningTGDuration: '0 min',
        })
      );
    }
  }, [newScreening?.allTests]);

  const formatFilters = (filters) => {
    const formattedCategories = filters?.category?.join(',');
    const formattedTags = filters?.levelId.join(',');
    const formattedRoles = filters?.rolesIds.join(',');
    const formattedSelectedRole = filters?.selectedRole?.id ?? '';
    const formattedLanguage = filters?.language ?? null;
    return {
      name: filters?.name,
      tagsIds: formattedTags,
      categoryId: formattedCategories,
      rolesIds: formattedRoles.length ? formattedRoles : formattedSelectedRole,
      lang: formattedLanguage,
    };
  };

  const disableAddTextQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.TEXT &&
    !newScreening?.currentQuestionData?.maxChar > 0;

  const disableAddWriteQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.WRITE &&
    !newScreening?.currentQuestionData?.writeResponse;

  const disableAddChallengeAsyncQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.CHALLENGE_ASYNC_AI &&
    (!newScreening?.currentQuestionData?.promptSubType ||
      !newScreening?.currentQuestionData?.testFiles?.length ||
      !newScreening?.currentQuestionData?.rubricsTestAI);

  const disableAddTextIaQuestion =
    (newScreening?.currentTypeQuestion === AnswerTypeEnum.TEXT_AI &&
      [
        PromptSubTypes.CONCEPTS_CORRECTION,
        PromptSubTypes.SFIA_CORRECTION,
        PromptSubTypes.SHORT_ANSWER_CORRECTION,
      ].includes(
        newScreening?.currentQuestionData?.promptSubType &&
          (!newScreening?.currentQuestionData?.maxChar > 0 ||
            !newScreening?.currentQuestionData?.concepts?.length)
      )) ||
    ([PromptSubTypes.TRANSCRIPTION_CORRECTION, PromptSubTypes.ORTHOGRAPHY_CORRECTION].includes(
      newScreening?.currentQuestionData?.promptSubType
    ) &&
      !newScreening?.currentQuestionData?.concepts?.length);

  const disableAddFileQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.FILE &&
    !newScreening?.currentQuestionData?.fileTypes?.length;

  const disableAddCheckQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.CHECK &&
    (!newScreening?.currentQuestionData?.options?.length >= 2 ||
      !newScreening?.currentQuestionData?.options?.some((answer) => answer?.correct === true) ||
      !newScreening?.currentQuestionData?.options?.every(
        (answer) => answer?.text.length || answer?.files?.length
      ));

  const disableAddCodeQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.CODE &&
    !newScreening?.currentQuestionData?.langCode &&
    !newScreening?.currentQuestionData?.expectedResult &&
    !newScreening?.currentQuestionData?.expectedResult?.some(
      (answer) => answer?.input !== '' && answer?.output !== ''
    );

  const disableAddVideoAIQuestion =
    newScreening?.currentTypeQuestion === AnswerTypeEnum.VIDEO_AI &&
    (!newScreening?.currentQuestionData?.preparationTime ||
      !newScreening?.currentQuestionData?.totalTime ||
      !newScreening?.currentQuestionData?.maxAttempts);

  const disableWithoutWeight = !newScreening?.currentQuestionData?.weight;

  const preventReloadCondition = Boolean(
    newScreening?.name?.length || newScreening?.allTests?.length
  );

  const fileTypes = [
    {
      id: FilesType.IMAGE,
      displayName: t('CREATE_SCREENING_YOUR_QUESTIONS_FILE_TYPE_IMAGE'),
    },
    {
      id: FilesType.VIDEO,
      displayName: t('CREATE_SCREENING_YOUR_QUESTIONS_FILE_TYPE_VIDEO'),
    },
    {
      id: FilesType.CSV,
      displayName: t('CREATE_SCREENING_YOUR_QUESTIONS_FILE_TYPE_CSV'),
    },
    {
      id: FilesType.PDF,
      displayName: t('CREATE_SCREENING_YOUR_QUESTIONS_FILE_TYPE_PDF'),
    },
    {
      id: FilesType.TEXT,
      displayName: t('CREATE_SCREENING_YOUR_QUESTIONS_FILE_TYPE_TEXT'),
    },
  ];

  const formatCustomTestGroupToPost = (customTestGroup) =>
    customTestGroup
      ? {
          name: customTestGroup.name,
          order: customTestGroup.order,
          duration: customTestGroup.duration,
          weight: customTestGroup.weight ?? 0,
          hasSkipQuestion: customTestGroup?.hasSkipQuestion,
          categoryId: CategoriesIdDefined.CUSTOM,
          type: TestGroupTypes.CUSTOM,
          tests: formatOrder(
            customTestGroup.tests.map((item) => ({
              ...item,
              answerType:
                item.answerType === AnswerTypeEnum.CHECK &&
                item.options.filter((option) => option.correct).length === 1
                  ? AnswerTypeEnum.RADIO
                  : item.answerType,
              id: undefined,
              weight: 1,
              companyId: user?.workspaces.filter(
                (workspace) => workspace.workspaceId === currentWorkspace
              )[0].companyId,
            }))
          ),
          screeningSortStrategy: customTestGroup?.screeningSortStrategy,
          // Include recordingConfig only if AI_INTERVIEW strategy is set
          ...(customTestGroup?.screeningSortStrategy === SCREENING_SORT_STRATEGY.AI_INTERVIEW ||
          customTestGroupStrategy === StrategyValues.AI_INTERVIEW
            ? {
                recordingConfig: customTestGroup?.recordingConfig?.mode
                  ? customTestGroup.recordingConfig
                  : recordingConfig?.mode
                  ? recordingConfig
                  : { mode: RecordingMode.AUDIO_ONLY },
              }
            : {}),
        }
      : undefined;

  const formatChallengeTestGroupToPost = (challengeTestGroup) =>
    challengeTestGroup
      ? {
          name: challengeTestGroup.name,
          order: challengeTestGroup.order,
          duration: challengeTestGroup.duration,
          weight: challengeTestGroup.weight ?? 0,
          hasSkipQuestion: false,
          withoutTime: true,
          type: TestGroupTypes.CHALLENGE_ASYNC_AI,
          categoryId: CategoriesIdDefined.CHALLENGE_ASYNC_AI,
          tests: formatOrder(
            challengeTestGroup.tests.map((item) => ({
              ...item,
              id: undefined,
              weight: 1,
              companyId: user?.workspaces.filter(
                (workspace) => workspace.workspaceId === currentWorkspace
              )[0].companyId,
            }))
          ),
        }
      : undefined;

  const handlePostData = async () => {
    const customTestGroup = newScreening?.allTests?.find(
      (item) => item.type === TestGroupTypes.CUSTOM
    );
    const formattedCustomTestGroup = formatCustomTestGroupToPost(customTestGroup);

    const challengeTestGroup = newScreening?.allTests?.find(
      (item) => item.type === TestGroupTypes.CHALLENGE_ASYNC_AI
    );
    const formattedChallengeTestGroup = formatChallengeTestGroupToPost(challengeTestGroup);

    const formattedTestGroups = formatOrder([
      ...newScreening?.allTests.filter((item) => !item.type),
      formattedCustomTestGroup,
      formattedChallengeTestGroup,
    ]).map((item) => ({
      ...item,
      tests: item.tests.map((test) => ({
        ...test,
        companyId: user?.workspaces.filter(
          (workspace) => workspace.workspaceId === currentWorkspace
        )[0].companyId,
      })),
    }));
    const dataToPost = {
      name: newScreening?.name,
      duration: testsDuration + customScreeningTotalTime,
      testGroups: formattedTestGroups,
      availableWeight: localAvailableWeight,
      companyId: user?.workspaces.filter(
        (workspace) => workspace.workspaceId === currentWorkspace
      )[0].companyId,
    };
    await postScreening(dataToPost)
      .then(() => {
        dispatch(
          setNewScreeningData({
            ...newScreening,
            step: newScreening.step + 1,
          })
        );
      })
      .catch(() =>
        notification.open({
          message: t('CREATE_SCREENING_ERROR_CREATING'),
          type: 'error',
        })
      );
    await getScreenings(user?.workspaces[0]?.workspaceId).then((screenings) => {
      dispatch(setScreenings(screenings));
    });
  };

  const fetchNextPage = () => {
    setLoading(true);
    const formattedFilters = formatFilters(newScreeningFilters);

    const nextFilters = processQueryString(testGroups.pagination.nextPage ?? '');
    getScreeningTestGroups({
      ...nextFilters,
      ...formattedFilters,
      offset: testGroups.pagination.offset + 1,
    }).then((res) => {
      dispatch(
        setTestGroupsData({
          collection: [...testGroups.collection, ...res.collection],
          pagination: res.pagination,
        })
      );
      setLoading(false);
    });
  };

  const handleCurrentTypeQuestion = (questionTypeId) => {
    const textTypes = [
      AnswerTypeEnum.TEXT,
      AnswerTypeEnum.TEXT_AI,
      AnswerTypeEnum.VIDEO,
      AnswerTypeEnum.VIDEO_AI,
      AnswerTypeEnum.CODE_AI,
      AnswerTypeEnum.CODE,
      AnswerTypeEnum.WRITE,
      AnswerTypeEnum.CHALLENGE_ASYNC_AI,
    ];

    const shouldPreserveCurrentQuestionData =
      textTypes.includes(newScreening.currentTypeQuestion) && textTypes.includes(questionTypeId);

    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentTypeQuestion: questionTypeId,
        isEdit: false,
      })
    );
  };

  const handleAddPromptChallengeAI = (promptId) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          promptSubType: promptId,
        },
      })
    );
  };

  const handleAddPrompTextAI = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          promptSubType: e?.promptId,
          maxChar: [
            PromptSubTypes.CONCEPTS_CORRECTION,
            PromptSubTypes.SFIA_CORRECTION,
            PromptSubTypes.SHORT_ANSWER_CORRECTION,
          ].includes(e?.promptId)
            ? newScreening?.currentQuestionData?.maxChar
            : 5000,
          concepts: ![
            PromptSubTypes.CONCEPTS_CORRECTION,
            PromptSubTypes.TRANSCRIPTION_CORRECTION,
            PromptSubTypes.ORTHOGRAPHY_CORRECTION,
            PromptSubTypes.SHORT_ANSWER_CORRECTION,
            PromptSubTypes.SFIA_CORRECTION,
          ].includes(e?.promptId)
            ? null
            : newScreening?.currentQuestionData?.concepts,
        },
      })
    );
  };

  const handleAddQuestionText = (e) => {
    if (e.target.name === 'maxChar') {
      if (e.target.value >= 0 && e.target.value <= 5000) {
        dispatch(
          setNewScreeningData({
            ...newScreening,
            currentQuestionData: {
              ...newScreening.currentQuestionData,
              maxChar: e.target.value ? Number(e.target.value) : '',
            },
          })
        );
      }
    } else if (e.target.name === 'weight') {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: {
            ...newScreening.currentQuestionData,
            weight: Math.min(10, Number(e.target.value)),
          },
        })
      );
    } else {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: {
            ...newScreening.currentQuestionData,
            [e.target.name]: e.target.value,
          },
        })
      );
    }
  };

  const handleAddQuestionWrite = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          [e.target.name]: e.target.value,
        },
      })
    );
  };

  const handleAddQuestionDraw = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          [e.target.name]: e.target.value,
        },
      })
    );
  };

  const handleAddQuestionChallengeAsync = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          [e.target.name]: e.target.value,
        },
      })
    );
  };

  const handleToggleIsTyping = (action) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          isTyping: action,
        },
      })
    );
  };

  const handleAddQuestionDifficulty = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          difficultyId: e.id,
          weight: e.weight,
        },
      })
    );
  };

  const handleAddQuestionWeight = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          weight: e?.weight,
        },
      })
    );
  };

  const handleAddQuestionDuration = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          duration: e?.duration,
        },
      })
    );
  };

  const handleAddQuestionType = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          questionType: e?.questionType,
        },
      })
    );
  };

  const handleAddBloomTaxonomy = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          bloomTaxonomy: e?.bloomTaxonomy,
        },
      })
    );
  };

  const handleAddQuestionExplanation = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          explanation: e.target.value,
        },
      })
    );
  };

  const handleAddQuestionSubskills = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          subSkillIds: e,
        },
      })
    );
  };

  const removeLangCodeProperties = (type) => {
    const updatedQuestionData = {
      ...newScreening.currentQuestionData,
      answerType: type,
    };

    delete updatedQuestionData.langCode;
    delete updatedQuestionData.langVersion;
    delete updatedQuestionData.langDisplayName;

    const updatedScreeningData = {
      ...newScreening,
      currentTypeQuestion: type,
      currentQuestionData: updatedQuestionData,
    };

    dispatch(setNewScreeningData(updatedScreeningData));
  };

  const handleAddQuestionLanguage = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          langCode: e.id,
          langVersion: e.id,
          langDisplayName: e.name,
          type: AnswerTypeEnum.CODE,
        },
      })
    );
  };

  const fetchLevels = () => {
    getTags({ types: 'LEVEL' }).then((res) => dispatch(setNewScreeningLevelsFiltersOptions(res)));
  };

  const fetchCategories = async (withTestGroups) => {
    if (withTestGroups) {
      await getCategoriesWithTestGroups().then((res) =>
        dispatch(
          setNewScreeningCategoriesFiltersOptions(
            sortArrayAlphabeticallyByPropertyName(res, 'name')
          )
        )
      );
    } else {
      await getCategoriesAll().then((res) =>
        dispatch(
          setNewScreeningCategoriesFiltersOptions(
            sortArrayAlphabeticallyByPropertyName(res, 'name')
          )
        )
      );
    }
  };

  const fetchRoles = async () => {
    await getRolesAll().then((res) => {
      const sortedRoles = sortArrayAlphabeticallyByPropertyName(res, 'displayName');
      dispatch(setNewScreeningRolesFiltersOptions(sortedRoles));
    });
  };

  const fetchTags = async (req = {}) => {
    await getTags(req).then((res) => {
      dispatch(setNewScreeningTagsFiltersOptions(res));
    });
  };

  const fetchPrefilterQuestions = async () => {
    const workspaceInfo = getLocalStorageWorkspace();
    const questions = await getPrefilterQuesitons({ companyId: workspaceInfo?.companyId });
    dispatch(
      updateNewScreeningProperty({
        prefilterQuestionsCompanyOptions: questions.collection,
      })
    );
    return questions;
  };

  const searchPrefilterQuestionsText = async (text, filterType = 'ALL') => {
    const workspaceInfo = getLocalStorageWorkspace();
    const questions = await getPrefilterQuesitons({ companyId: workspaceInfo?.companyId });

    let filteredQuestions = questions.collection;

    // Filtrar por texto
    if (text && text.trim() !== '') {
      const searchLower = text.toLowerCase();
      filteredQuestions = filteredQuestions.filter((q) => {
        const questionText = q.test?.text?.toLowerCase() || '';
        const answerTypeLabel = t(`CREATE_PREFILTER_QUESTIONS_${q.test?.answerType}`).toLowerCase();
        return questionText.includes(searchLower) || answerTypeLabel.includes(searchLower);
      });
    }

    // Filtrar por tipo
    if (filterType !== 'ALL') {
      filteredQuestions = filteredQuestions.filter((q) => q.test?.answerType === filterType);
    }

    dispatch(
      updateNewScreeningProperty({
        prefilterQuestionsCompanyOptions: filteredQuestions,
      })
    );
    return filteredQuestions;
  };

  const fetchAdditionalQuestions = async () => {
    const workspaceInfo = getLocalStorageWorkspace();
    const questions = await getAdditionalQuestions({ workspaceId: workspaceInfo?.workspaceId });
    dispatch(
      updateNewScreeningProperty({
        additionalQuestionsCompanyOptions: questions.collection,
      })
    );
    return questions;
  };

  const searchAdditionalQuestionsText = async (text, filterType = 'ALL') => {
    const workspaceInfo = getLocalStorageWorkspace();
    const questions = await searchAdditionalQuestions({
      workspaceId: workspaceInfo?.workspaceId,
      text: text || '',
    });

    let filteredQuestions = questions;

    // Buscar por tipo traducido si no hay texto o si el texto coincide con una traducción
    if (text && text.trim() !== '') {
      const searchLower = text.toLowerCase();
      filteredQuestions = questions.filter((q) => {
        const questionText = q.text?.toLowerCase() || '';
        const answerTypeLabel = t(`CREATE_SCREENING_YOUR_QUESTIONS_${q.answerType}`).toLowerCase();
        return questionText.includes(searchLower) || answerTypeLabel.includes(searchLower);
      });
    }

    // Filtrar por tipo
    if (filterType !== 'ALL') {
      filteredQuestions = filteredQuestions.filter((q) => q.answerType === filterType);
    }

    dispatch(
      updateNewScreeningProperty({
        additionalQuestionsCompanyOptions: filteredQuestions,
      })
    );
    return filteredQuestions;
  };

  const handleDeleteAdditionalQuestion = async (questionId) => {
    try {
      await deleteAdditionalQuestion(questionId);
      const filterAdditionalQuestions = newScreening?.additionalQuestionsCompanyOptions?.filter(
        (q) => q.testId !== questionId
      );
      dispatch(
        updateNewScreeningProperty({
          additionalQuestionsCompanyOptions: filterAdditionalQuestions,
        })
      );
      await fetchAdditionalQuestions();
      notification.open({ type: 'success', message: t('DELETE_ADDITIONAL_QUESTION_MESSAGE') });
    } catch (e) {
      notification.open({ type: 'error', message: t('ERROR_ON_ADDITIONAL_QUESTIONS') });
    }
  };

  const handleEditAdditionalTestQuestion = async (data) => {
    await editAdditionalQuestion(data.testId, data);
    await fetchAdditionalQuestions();
    return;
  };

  const fetchPromptCorrectionTextAI = async (testGroupABM) => {
    const promptsCorrectionTextAI = await getPromptCorrectionTextAI(testGroupABM);
    dispatch(setPromptCorrectionTextAI(promptsCorrectionTextAI));
    return promptsCorrectionTextAI;
  };

  const fetchEndorsementCreators = async (req = {}) => {
    const res = await getEndorsements({ ...req, type: 'CREATOR' });
    dispatch(setEndorsementCreatorsOptions(res));
  };

  const fetchEndorsementCompanies = async (req = {}) => {
    await getEndorsements({ ...req, type: 'COMPANY' }).then((res) => {
      dispatch(setEndorsementCompaniesOptions(res));
    });
  };

  const fetchRolesWithTestGroups = async () => {
    await getRolesWithTestGropusFilters().then((res) => {
      const sortedRoles = sortArrayAlphabeticallyByPropertyName(res, 'displayName');
      dispatch(setNewScreeningRolesFiltersOptions(sortedRoles));
    });
  };

  const fetchQuickRolesWithTestGroups = async () => {
    await getQuickRolesWithTestGroups().then((res) => {
      const sortedQuickRoles = sortArrayAlphabeticallyByPropertyName(res, 'displayName');
      dispatch(setNewScreeningQuickRolesOptions(sortedQuickRoles));
    });
  };

  const fetchWelcomeVideos = async () => {
    const videoOfCompany = await getVideosForCompany(1);
    const videoData = videoOfCompany.map((v) => ({ id: v.videoUrl, name: v.videoTitle }));
    setWelcomeVideos(videoData);
  };

  const addCustomWelcomeVideo = (customVideo) => {
    const copyVideos = [...welcomeVideos];
    copyVideos.push({ id: customVideo.welcomeVideoUrl, name: customVideo.welcomeVideoTitle });
    setWelcomeVideos(copyVideos);
  };

  const deleteCustomWelcomeVideo = () => {
    const copyVideos = welcomeVideos.filter((v) => v.name !== newScreening.welcomeVideoTitle);
    setWelcomeVideos(copyVideos);
  };

  const handleAddVideoInfo = (video) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        welcomeVideoTitle: video.welcomeVideoTitle,
        welcomeVideoUrl: video.welcomeVideoUrl,
      })
    );
  };

  const handleAddAnswers = (rowAnswer) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          options: rowAnswer,
        },
      })
    );
  };

  const handleAddCodeAnswers = (rowAnswer) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          expectedResult: rowAnswer,
        },
      })
    );
  };

  const handleScreeningName = (e) => {
    if (newScreening.name.length <= 50) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          name: e.target.value,
        })
      );
    }
  };

  const handleTests = (test, isSelectTests = false) => {
    if (isSelectTests) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          /* Comment the line and take the testgroup out of the selected ones */
          // testGroups: newScreening.testGroups.map((testGroup) => {
          //   if (testGroup.id === test.id) {
          //     return { ...testGroup, isSelected: !testGroup.isSelected };
          //   }

          //   return testGroup;
          // }),
          testGroups: newScreening.testGroups.filter((item) => item.id !== test.id),
          allTests: formatOrder(
            newScreening.allTests.map((testGroup) => {
              if (testGroup.id === test.id) {
                return { ...testGroup, isSelected: !testGroup.isSelected };
              }
              return testGroup;
            })
          ),
        })
      );
    } else {
      const existingTest = newScreening.testGroups.find((item) => item.id === test.id);
      if (existingTest) {
        dispatch(
          setNewScreeningData({
            ...newScreening,
            testGroups: newScreening.testGroups.filter((item) => item.id !== test.id),
            allTests: formatOrder(newScreening.allTests.filter((item) => item.id !== test.id)),
          })
        );
      } else {
        dispatch(
          setNewScreeningData({
            ...newScreening,
            testGroups: [...newScreening?.testGroups, { ...test, isSelected: true }],
            allTests: formatOrder([...newScreening.allTests, { ...test, isSelected: true }]),
          })
        );
      }
    }
  };

  const handleNextStep = () => {
    if (newScreening.step < 4) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          name: newScreening.name.trim(),
          step: newScreening.step + 1,
        })
      );
    } else {
      TrackEventGTM(EventsGTM.CREATE_EVALUATION, {
        event_category: 'Step 4 create evaluation',
        event_action: 'click',
      });
      handlePostData();
    }
  };

  const handlePreviousStep = () => {
    if (newScreening.step > 1) {
      TrackEventGTM(EventsGTM.CREATE_EVALUATION, {
        event_category: `Go Back to step ${newScreening.step - 1}`,
        event_action: 'click',
      });
      dispatch(
        setNewScreeningData({
          ...newScreening,
          step: newScreening.step - 1,
        })
      );
    }
  };

  const handleInput = (event) => {
    dispatch(
      setNewScreeningFilters({
        ...newScreeningFilters,
        name: event.target.value,
      })
    );
  };

  const handleSetModalTestSuggestionAI = (show) => {
    dispatch(setModalTestSuggestionAI(show));
  };

  const [lastNameFetched, setLastNameFetched] = useState('');

  const handleSubmit = async (event, removeRoles) => {
    event.preventDefault();
    const formattedFilters = formatFilters(newScreeningFilters);
    const filters = newScreeningFilters;
    delete filters.selectedRole;
    let screening;

    if (lastNameFetched !== formattedFilters?.name) {
      TrackEventGTM(EventsGTM.SEARCH_TEST_BY_TEXT, {
        event_category: 'Search by text tesgroup',
        filter_test_text: formattedFilters?.name,
        filter_test_category: formattedFilters?.categoryId,
        filter_test_roles: formattedFilters?.rolesIds,
        filter_test_lang: formattedFilters?.lang,
        event_action: 'testgroup filter',
      });
      setLoading(true);
      screening = getScreeningTestGroups({
        ...formattedFilters,
        ...(removeRoles ? { rolesIds: '' } : {}),
      }).then((res) => {
        setLastNameFetched(formattedFilters?.name);
        dispatch(setTestGroupsData(res));
        setLoading(false);
        const filtersApplied = filters
          ? Object.values(filters)
              .flat()
              .filter((e) => e !== '')
          : [];
        dispatch(setAmountOfFilters(filtersApplied.length));
      });
    }
    return screening;
  };

  const handleSelectFilterOption = (optionId, filterType, isFavorite) => {
    const selectedOption = newScreeningFilters[filterType]?.includes(optionId);
    let filters = newScreeningFilters;
    delete filters.selectedRole;
    if (selectedOption) {
      filters = {
        ...newScreeningFilters,
        [filterType]: newScreeningFilters[filterType]?.filter((item) => item !== optionId),
      };
    } else {
      filters = {
        ...newScreeningFilters,
        [filterType]: [...newScreeningFilters[filterType], optionId],
      };
    }
    if (['rolesIds'].includes(filterType)) {
      filters = { ...filters, category: [], levelId: [], name: '', language: [] };
    } else {
      filters = { ...filters, rolesIds: [] };
    }
    const filtersApplied = filters
      ? Object.values(filters)
          .flat()
          .filter((e) => e !== '')
      : [];

    dispatch(setAmountOfFilters(filtersApplied.length));
    dispatch(setNewScreeningFilters(filters));
    const formattedFilters = formatFilters(filters);
    setLoading(true);
    return getScreeningTestGroups({
      ...formattedFilters,
      ...(isFavorite && { favorites: true }),
    }).then((res) => {
      dispatch(setTestGroupsData(res));
      setLoading(false);
      if (pathname === TESTS) dispatch(setNPSProcessType(NPSProcessTypes.TEST_CATALOG_SEARCHED));
    });
  };

  const handleInitialSetUpLangCodesAIOptions = (options, rubrics) => {
    const transformedRubrics = rubrics.reduce((acc, rubric) => {
      if (rubric.value > 0) {
        acc[rubric.id] = rubric.value;
      }
      return acc;
    }, {});

    dispatch(
      setNewScreeningData({
        ...newScreening,
        langCodesAIOptions: options.map((option) => option.id),
        langCodesAIRubrics: transformedRubrics,
      })
    );
  };

  const handleInitialSetUpTestChallengeAI = (promptId, rubrics) => {
    const transformedRubrics = rubrics.reduce((acc, rubric) => {
      if (rubric.value > 0) {
        acc[rubric.id] = rubric.value;
      }
      return acc;
    }, {});

    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...(newScreening.currentQuestionData || {}),
          promptSubType: promptId,
          rubricsTestAI: transformedRubrics,
        },
      })
    );
  };

  const handleLangCodesAIRubrics = (rubrics) => {
    const updatedObject = {
      ...newScreening,
      langCodesAIRubrics: rubrics,
    };
    dispatch(setNewScreeningData(updatedObject));
  };

  const handleSelectLangCodesAIOption = (arrayOptionsId) => {
    const optionsSelected = {
      ...newScreening,
      langCodesAIOptions: arrayOptionsId,
    };
    dispatch(setNewScreeningData(optionsSelected));
  };

  const handleAddTestRubrics = (arrayOptionsId) => {
    const optionsSelected = {
      ...newScreening,
      currentQuestionData: {
        ...newScreening.currentQuestionData,
        rubricsTestAI: arrayOptionsId,
      },
    };
    dispatch(setNewScreeningData(optionsSelected));
  };

  const handleSelectFilterOptionMultiple = (optionId = [], filterType, isFavorite) => {
    let filters = newScreeningFilters;
    delete filters.selectedRole;
    filters = {
      ...newScreeningFilters,
      [filterType]: optionId,
    };

    if (['rolesIds'].includes(filterType)) {
      filters = { ...filters, category: [], levelId: [], name: '' };
    } else {
      filters = { ...filters, rolesIds: [] };
    }
    const filtersApplied = filters
      ? Object.values(filters)
          .flat()
          .filter((e) => e !== '')
      : [];

    dispatch(setAmountOfFilters(filtersApplied.length));
    dispatch(setNewScreeningFilters(filters));
    const formattedFilters = formatFilters(filters);
    setLoading(true);
    return getScreeningTestGroups({
      ...formattedFilters,
      ...(isFavorite && { favorites: true }),
    }).then((res) => {
      dispatch(setTestGroupsData(res));
      setLoading(false);
      if (pathname === TESTS) dispatch(setNPSProcessType(NPSProcessTypes.TEST_CATALOG_SEARCHED));
    });
  };

  const handleClearFilters = (isFavorite = false, getScreenings = true) => {
    dispatch(
      setNewScreeningFilters({
        ...newScreeningFilters,
        category: [],
        levelId: [],
        name: '',
        rolesIds: [],
        selectedRole: {},
        language: [],
        ...(isFavorite && { favorites: true }),
      })
    );
    dispatch(setAmountOfFilters(0));
    setLastNameFetched('');
    setLoading(true);
    let screening;
    if (getScreenings) {
      screening = getScreeningTestGroups({
        ...(isFavorite && { favorites: true }),
      }).then((res) => {
        dispatch(setTestGroupsData(res));
        setLoading(false);
      });
    }
    return screening;
  };

  const handleOrder = (currentOrder, nextOrder, arrayToOrder) => {
    const currentOrderItem = newScreening[arrayToOrder]?.find(
      (item) => item.order === currentOrder
    );
    const nextOrderItem = newScreening[arrayToOrder]?.find((item) => item.order === nextOrder);

    if (!currentOrderItem || !nextOrderItem) return;

    const filteredData =
      newScreening[arrayToOrder]?.filter(
        (item) => item.id !== nextOrderItem.id && item.id !== currentOrderItem.id
      ) || [];

    const currentOrderItemTG = newScreening.testGroups?.find(
      (item) => item.id === currentOrderItem.id
    );
    if (currentOrderItemTG) {
      currentOrderItemTG.order = nextOrder;
    }
    const nextOrderItemTG = newScreening.testGroups?.find((item) => item.id === nextOrderItem.id);

    if (nextOrderItemTG) {
      nextOrderItemTG.order = currentOrder;
    }
    const filteredDataTG =
      newScreening.testGroups?.filter(
        (item) => item.id !== nextOrderItemTG?.id && item.id !== currentOrderItemTG?.id
      ) || [];

    currentOrderItem.order = nextOrder;
    nextOrderItem.order = currentOrder;

    dispatch(
      setNewScreeningData({
        ...newScreening,
        [arrayToOrder]: [...filteredData, nextOrderItem, currentOrderItem].filter(Boolean),
        testGroups: [...filteredDataTG, nextOrderItemTG, currentOrderItemTG].filter(Boolean),
      })
    );
  };

  const handleOrderByIndex = (index, indexToTake, arrayToOrder) => {
    const copyArray = [...newScreening[arrayToOrder]];
    if (index < indexToTake) {
      [copyArray[index], copyArray[indexToTake]] = [copyArray[indexToTake], copyArray[index]];
    } else {
      [copyArray[indexToTake], copyArray[index]] = [copyArray[index], copyArray[indexToTake]];
    }
    dispatch(
      setNewScreeningData({
        ...newScreening,
        [arrayToOrder]: copyArray,
      })
    );
  };

  const getLeafSubSkillIdsFromTest = (test) => {
    if (!test?.subSkills || test?.subSkills?.length === 0) return [];
    const allParentIds = new Set(test.subSkills.map((skill) => skill.parentId).filter(Boolean));
    return test.subSkills.filter((skill) => !allParentIds.has(skill.id)).map((skill) => skill.id);
  };

  const handleDelete = (id) => {
    const removedData = formatOrder(
      newScreening?.customTestGroup?.filter((item) => item.id !== id && item.deleteId !== id)
    );
    const finalTime = removedData.length ? newScreening.customScreeningTGDuration : '0 min';
    const allTestsFormatted = removedData.length
      ? newScreening.allTests
      : newScreening?.allTests.filter(
          (item) =>
            item?.type !== TestGroupTypes.CUSTOM && item?.type !== TestGroupTypes.CHALLENGE_ASYNC_AI
        );

    const testsDeleted = newScreening?.customTestGroup
      ?.filter((item) => item.id === id)
      .map((test) => ({ ...test, action: TestEditionAction.DELETE }));

    const testChallengeDeleted = newScreening?.challengeTestGroup
      ?.filter((item) => item.id === id)
      .map((test) => ({ ...test, action: TestEditionAction.DELETE }));

    if (newScreening?.isEdit && newScreening?.currentQuestionData?.id === id) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: undefined,
          customScreeningTGDuration: finalTime,
          isEdit: false,
          customTestGroup: removedData,
          allTests: allTestsFormatted,
          deleteTests: (newScreening.deleteTests ?? [])
            .concat(testsDeleted)
            .concat(testChallengeDeleted),
        })
      );
    } else {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          customTestGroup: removedData,
          customScreeningTGDuration: finalTime,
          allTests: allTestsFormatted,
          deleteTests: (newScreening.deleteTests ?? [])
            .concat(testsDeleted)
            .concat(testChallengeDeleted),
        })
      );
    }
  };

  const setEachScore = () =>
    dispatch(
      setNewScreeningData({
        ...newScreening,
        eachScore: !newScreening.eachScore,
      })
    );

  const setEachScoreValue = (value) =>
    dispatch(
      setNewScreeningData({
        ...newScreening,
        eachScore: value,
      })
    );

  const setEditData = (test) => {
    if (Window()) {
      window.scrollTo({ top: -20, behavior: 'smooth' });
    }
    setTimeout(() => {
      if ([AnswerTypeEnum.CHECK, AnswerTypeEnum.RADIO].includes(test.answerType)) {
        dispatch(
          setNewScreeningData({
            ...newScreening,
            currentTypeQuestion: test.answerType,
            currentQuestionData: { ...test, subSkillIds: getLeafSubSkillIdsFromTest(test) },
            isEdit: true,
            eachScore: !test?.hasGlobalScore,
          })
        );
      } else {
        dispatch(
          setNewScreeningData({
            ...newScreening,
            currentTypeQuestion: test.answerType,
            currentQuestionData: { ...test, subSkillIds: getLeafSubSkillIdsFromTest(test) },
            isEdit: true,
          })
        );
      }
    }, 0);
  };

  const determineAudioDuration = (audio) => {
    if (!audio) return null;

    const duration =
      !audio?.infinitePlays && Number(audio?.numberOfPlays) > 0
        ? Math.round(audio?.duration) * Number(audio?.numberOfPlays)
        : Math.round(audio?.duration) * 2;

    return duration;
  };

  const addQuestionsToTestGroup = (orderedQuestions) => {
    if (existingCustomTestGroup) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          customScreeningTGDuration:
            newScreening.currentTypeQuestion === AnswerTypeEnum.VIDEO
              ? null
              : newScreening?.customScreeningTGDuration,
          customTestGroup: orderedQuestions,
          currentQuestionData: {
            difficultyId: newScreening.currentQuestionData.difficultyId,
            promptSubType:
              newScreening.currentTypeQuestion === AnswerTypeEnum.TEXT_AI
                ? PromptSubTypes.SHORT_ANSWER_CORRECTION
                : null,
            weight: newScreening.currentQuestionData?.weight,
          },
        })
      );
      existingCustomTestGroup.tests = orderedQuestions;
    } else {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          customScreeningTGDuration:
            newScreening.currentTypeQuestion === AnswerTypeEnum.VIDEO
              ? null
              : newScreening?.customScreeningTGDuration,
          customTestGroup: orderedQuestions,
          currentQuestionData: {
            difficultyId: newScreening?.currentQuestionData?.difficultyId,
            promptSubType:
              newScreening?.currentTypeQuestion === AnswerTypeEnum.TEXT_AI
                ? PromptSubTypes.SHORT_ANSWER_CORRECTION
                : null,
            weight: newScreening?.currentQuestionData?.weight,
          },
          allTests: formatOrder([
            ...newScreening.allTests,
            {
              name: t('CREATE_SCREENING_CUSTOM_TEST_GROUP_TITLE'),
              type: TestGroupTypes.CUSTOM,
              duration: customTestGroupTotalTime,
              tests: orderedQuestions,
              id: v4(),
              screeningSortStrategy: getTestGroupScreeningStrategy(customTestGroupStrategy),
              ...(customTestGroupStrategy === StrategyValues.AI_INTERVIEW && recordingConfig
                ? { recordingConfig }
                : {}),
            },
          ]),
        })
      );
    }
  };

  const addChallengeQuestionsToTestGroup = (orderedQuestions) => {
    if (existingChallengeTestGroup) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          customChallengeTestGroup: orderedQuestions,
          currentQuestionData: undefined,
          currentTypeQuestion: AnswerTypeEnum.CHECK,
        })
      );
      existingChallengeTestGroup.tests = orderedQuestions;
    } else {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          customChallengeTestGroup: orderedQuestions,
          currentQuestionData: undefined,
          currentTypeQuestion: AnswerTypeEnum.CHECK,
          allTests: formatOrder([
            ...newScreening.allTests,
            {
              name: t('CREATE_SCREENING_CHALLENGE_TEST_GROUP_TITLE'),
              type: TestGroupTypes.CHALLENGE_ASYNC_AI,
              duration: 1,
              tests: orderedQuestions,
              id: v4(),
            },
          ]),
        })
      );
    }
  };

  const handleAddQuestion = (
    testGroupABM,
    isAdditional = false,
    catalogQuestions = null,
    flags = {}
  ) => {
    // Si se pasan preguntas de catálogo, usar ese flujo
    if (catalogQuestions) {
      const maxOrder = Math.max(
        0,
        ...(newScreening?.customTestGroup?.map((q) => q.order || 0) ?? [0])
      );

      const defaultFlags = {
        isAdditional: true,
        isEdited: false,
        ...flags,
      };

      const questionsToAdd = catalogQuestions.map((q, index) => ({
        ...q,
        deleteId: v4(),
        id: q.testId || q.id || `temp-${v4()}`,
        testId: q.testId || q.id,
        action: TestEditionAction.CREATE,
        ...defaultFlags,
        order: maxOrder + index + 1,
      }));

      const orderedQuestions = formatOrder([...newScreening?.customTestGroup, ...questionsToAdd]);

      addQuestionsToTestGroup(orderedQuestions);
      return;
    }

    // Flujo original para preguntas del formulario
    // Solo validar weight para preguntas que lo requieren (excluir VIDEO y TEXT)
    const requiresWeight =
      testGroupABM &&
      newScreening.currentTypeQuestion !== AnswerTypeEnum.VIDEO &&
      newScreening.currentTypeQuestion !== AnswerTypeEnum.TEXT;

    if (requiresWeight && !newScreening?.currentQuestionData?.weight) {
      notification.open({
        message: t('ABM_ERROR_NO_MAXSCORE_CREATION'),
        type: 'error',
      });
      return;
    }
    if (newScreening.currentTypeQuestion !== AnswerTypeEnum.CHALLENGE_ASYNC_AI) {
      const orderedQuestions = formatOrder([
        ...newScreening?.customTestGroup,
        {
          ...newScreening?.currentQuestionData,
          deleteId: v4(),
          id: `temp-${v4()}`,
          answerType: newScreening.currentTypeQuestion,
          action: TestEditionAction.CREATE,
          eachScore: newScreening.eachScore,
          hasGlobalScore: !newScreening.eachScore,
          isAdditional: !testGroupABM && isAdditional, // Solo para custom test groups
        },
      ]);

      addQuestionsToTestGroup(orderedQuestions);
    } else {
      const newChallengeTestGroup = [
        {
          ...newScreening?.currentQuestionData,
          deleteId: v4(),
          id: `temp-${v4()}`,
          answerType: newScreening.currentTypeQuestion,
          action: TestEditionAction.CREATE,
          isAdditional: !testGroupABM && isAdditional,
        },
      ];

      addChallengeQuestionsToTestGroup(newChallengeTestGroup);
    }
  };

  const handleSetNewScreeningSuggestion = (tests) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        testSuggestionsData: tests,
      })
    );
  };

  const handleAddSuggestionData = () => {
    const orderedQuestions = formatOrder([
      ...newScreening?.customTestGroup,
      ...newScreening?.testSuggestionsData?.map((sugestedTest) => ({
        ...sugestedTest,
        deleteId: v4(),
        id: `temp-${v4()}`,
        answerType: newScreening.currentTypeQuestion,
        action: TestEditionAction.CREATE,
        eachScore: newScreening.eachScore,
        hasGlobalScore: !newScreening.eachScore,
        isTyping: sugestedTest.isTyping,
        promptSubType: getPromptSubTypeByCurrentTypeQuestion(newScreening.currentTypeQuestion),
      })),
    ]);
    addQuestionsToTestGroup(orderedQuestions);
  };

  const handleAddPrefilterQuestion = (questions) => {
    const copy = [...questions];
    dispatch(
      setNewScreeningData({
        ...newScreening,
        prefilterQuestions: copy,
      })
    );
  };

  const handleEditPrefilterQuestion = (question) => {
    const allQuestions = newScreening.prefilterQuestions.filter(
      (q) => q.testId !== question.testId
    );
    allQuestions.push(question);
    dispatch(
      setNewScreeningData({
        ...newScreening,
        prefilterQuestions: [...allQuestions],
      })
    );
  };

  const handleRemovePrefilterQuestion = (index) => {
    const questionFiltered = newScreening.prefilterQuestions.filter((_, i) => i !== index);
    dispatch(
      setNewScreeningData({
        ...newScreening,
        prefilterQuestions: [...questionFiltered],
      })
    );
  };

  const handleDeletePrefilterQuestion = async (questionId) => {
    try {
      await deletePrefilterQuesiton(questionId);
      const filterPrefilterQuestions = newScreening?.prefilterQuestions?.filter(
        (p) => p.testId !== questionId
      );
      dispatch(
        setNewScreeningData({
          ...newScreening,
          prefilterQuestions: filterPrefilterQuestions,
        })
      );
      await fetchPrefilterQuestions();
      notification.open({ type: 'success', message: t('DELETE_PREFILTER_QUESTION_MESSAGE') });
    } catch (e) {
      notification.open({ type: 'error', message: t('ERROR_ON_PREFILTER_QUESTIONS') });
    }
  };

  const handleEditPrefilterTestQuestion = async (data) => {
    await editPrefilterQuestion(data);
    const filterPrefilterQuestions = newScreening?.prefilterQuestions?.filter(
      (p) => p.testId !== data.testId
    );
    if (data?.answerType === AnswerTypeEnum.LOCATIONS) {
      delete data.acceptedOptions;
    }
    filterPrefilterQuestions.push({ ...data, testId: null });
    dispatch(
      setNewScreeningData({
        ...newScreening,
        prefilterQuestions: [...filterPrefilterQuestions],
      })
    );
    return filterPrefilterQuestions;
  };

  const handleAddPrefilterResponseDelay = (timeInHours) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        prefilterQuestionsDelay: Number(timeInHours),
      })
    );
  };

  const handleAddFileTypes = (fileType) => {
    const selectedOption =
      newScreening?.currentQuestionData?.fileTypes?.length &&
      newScreening?.currentQuestionData?.fileTypes?.find((item) => item === fileType);
    if (selectedOption) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: {
            ...newScreening.currentQuestionData,
            fileTypes: newScreening?.currentQuestionData?.fileTypes.filter(
              (item) => item !== fileType
            ),
          },
        })
      );
    } else {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: {
            ...newScreening?.currentQuestionData,
            fileTypes: [...(newScreening?.currentQuestionData?.fileTypes ?? []), fileType],
          },
        })
      );
    }
  };

  const handleEditQuestion = () => {
    const newOptions = newScreening?.customTestGroup.filter(
      (item) =>
        item?.id !== newScreening?.currentQuestionData?.id ||
        item?.deleteId !== newScreening?.currentQuestionData?.deleteId
    );

    const shouldMarkAsEdited =
      newScreening?.currentQuestionData?.isAdditional && newScreening?.currentQuestionData?.testId;

    const customTestGroupData = [
      ...newOptions,
      {
        ...newScreening?.currentQuestionData,
        action: newScreening?.currentQuestionData?.action ?? TestEditionAction.EDIT,
        ...(typeof newScreening.currentQuestionData.hasGlobalScore !== 'undefined'
          ? { hasGlobalScore: !newScreening.eachScore }
          : {}),
        ...(shouldMarkAsEdited ? { isEdited: true } : {}),
      },
    ];

    const orderedCustomTestGroup = formatOrder(customTestGroupData);

    const updatedAllTests = newScreening.allTests.map((testGroup) => {
      if (testGroup.type === TestGroupTypes.CUSTOM) {
        return {
          ...testGroup,
          tests: orderedCustomTestGroup,
        };
      }
      return testGroup;
    });

    // only mantain promptSubType if the strategy is AI interview agent
    const currentQuestionData = isAiInterviewStrategy(customTestGroupStrategy)
      ? { promptSubType: newScreening?.currentQuestionData?.promptSubType }
      : undefined;
    dispatch(
      setNewScreeningData({
        ...newScreening,
        customTestGroup: orderedCustomTestGroup,
        isEdit: false,
        currentQuestionData,
        allTests: formatOrder(updatedAllTests),
      })
    );
    notification.open({
      message: t('TEST_EDIT_SUCCESSFULLY'),
      type: 'success',
    });
  };

  const handleCustomTestGroupTime = (time) => {
    if (!time) return;

    dispatch(
      setNewScreeningData({
        ...newScreening,
        customTestGroupDuration: {
          hours: time.hour(),
          minutes: time.minute(),
        },
      })
    );
  };

  const handleCurrentQuestionDataTime = (propName, e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          [propName]: {
            ...(newScreening.currentQuestionData?.totalTime ?? {}),
            [e.target.name]: e.target.value,
          },
        },
      })
    );
  };
  const handleCurrentQuestionDataTimeDuration = (propName, data) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening?.currentQuestionData,
          [propName]: {
            ...(newScreening?.currentQuestionData
              ? newScreening?.currentQuestionData[propName]
              : {}),
            minutes: data?.value,
            ...data,
          },
        },
      })
    );
  };

  const handleCustomScreeningsTime = (e) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        customScreeningTGDuration: e?.id,
      })
    );
  };

  const modifyTestWeight = (id, value) => {
    const testGroupToModify = newScreening?.allTests?.find((item) => item.id === id);
    const newValue = Math.min(100, Number(value));
    const finalValue = !value
      ? undefined
      : newValue.toString().length >= 5
      ? newValue.toFixed(2)
      : newValue;
    testGroupToModify.weight = finalValue;
    let testGroup;
    if (
      testGroupToModify?.type !== TestGroupTypes.CUSTOM &&
      testGroupToModify?.type !== TestGroupTypes.CHALLENGE_ASYNC_AI
    ) {
      testGroup = newScreening?.testGroups?.find((item) => item.id === id);
      testGroup.weight = finalValue;
    }
    setLocalAvailableWeigth(calculateAvailableWeight(newScreening));
    dispatch(
      setNewScreeningData({
        ...newScreening,
        availableWeight: localAvailableWeight,
        testGroups: newScreening?.testGroups?.map((item) =>
          item?.id === testGroup?.id ? { ...item, ...testGroup } : item
        ),
        allTests: newScreening?.allTests?.map((item) =>
          item?.id === testGroup?.id ? { ...item, ...testGroup } : item
        ),
      })
    );
  };

  const handleDeleteCustomTestGroup = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        customTestGroup: [],
        isEdit: false,
        customScreeningTGDuration: '0 min',
        currentQuestionData: undefined,
        customTestGroupDuration: {
          hours: undefined,
          minutes: undefined,
          seconds: undefined,
        },
        allTests: formatOrder(
          newScreening?.allTests.filter((item) => item.type !== TestGroupTypes.CUSTOM)
        ),
      })
    );
  };

  const handleDeleteChallengeTestGroup = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        customChallengeTestGroup: [],
        currentQuestionData: undefined,
        allTests: formatOrder(
          newScreening?.allTests.filter((item) => item.type !== TestGroupTypes.CHALLENGE_ASYNC_AI)
        ),
      })
    );
  };

  const handleDeletePrefilterTest = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        prefilterQuestionsDelay: undefined,
        prefilterQuestions: [],
      })
    );
  };

  const goToFirstStep = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        step: 1,
      })
    );
  };

  const resetCheckWeight = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          options:
            newScreening.currentQuestionData?.options?.map((option) => ({
              text: option.text,
              files: [],
            })) ?? defaultCheckState,
        },
      })
    );
  };

  const isValidFileType = (file, expectedTypes) =>
    expectedTypes.some((type) => file.type.includes(type.toLowerCase()));

  const handleAddTestFile = async (file, fileType) => {
    if (file.size > maxBytesFile) {
      notification.open({
        message: t('UPLOAD_FILE_ERROR'),
        type: 'error',
      });
    } else if (!isValidFileType(file, [fileType])) {
      notification.open({
        message: t('UPLOAD_FILE_TYPE_ERROR'),
        type: 'error',
      });
    } else {
      const isAudioFile = fileType === TestFileType.AUDIO;
      const formattedFile = {
        ...file,
        id: v4(),
        fileType,
      };
      if (fileType === TestFileType.PDF) {
        const valid = await canReadPDF(file?.fileObject);
        if (!valid) {
          notification.open({
            message: t('UPLOAD_FILE_PDF_ERROR'),
            type: 'error',
          });
          return;
        }
      }

      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: {
            ...newScreening.currentQuestionData,
            testFiles: newScreening?.currentQuestionData?.testFiles
              ? newScreening.currentQuestionData.testFiles.concat(formattedFile)
              : [formattedFile],
            listeningTest: newScreening?.currentQuestionData?.listeningTest || isAudioFile,
          },
        })
      );
    }
  };

  const handleRemoveTestAudio = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          listeningTest: undefined,
          testFiles: undefined,
        },
      })
    );
  };

  const handleRemoveTestImage = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          image: undefined,
          testFiles: undefined,
        },
      })
    );
  };

  const handleRemoveTestFile = (fileId) => {
    const testFiles =
      newScreening?.currentQuestionData?.testFiles?.filter((file) => file.id !== fileId) ?? [];
    const listeningTest = testFiles.some((file) => file.fileType === TestFileType.AUDIO);
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          testFiles,
          listeningTest,
        },
      })
    );
  };

  const toggleInfinitePlay = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          infinitePlays:
            typeof newScreening.currentQuestionData?.infinitePlays === 'undefined' &&
            typeof newScreening.currentQuestionData?.numberOfPlays === 'undefined'
              ? false
              : !newScreening.currentQuestionData?.infinitePlays,
          ...(typeof newScreening.currentQuestionData?.numberOfPlays === 'undefined'
            ? { numberOfPlays: '' }
            : {}),
        },
      })
    );
  };

  const handleAddNumberOfPlays = (value) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          numberOfPlays: String(value),
        },
      })
    );
  };

  const deselectTg = () => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        testGroups: newScreening.testGroups.filter((testGroup) => !testGroup.isSelected),
        allTests: formatOrder(newScreening.testGroups.filter((testGroup) => !testGroup.isSelected)),
      })
    );
  };

  const handleUpdateTestFile = (fileId, dataToUpdate) => {
    const testFiles =
      newScreening?.currentQuestionData?.testFiles?.map((file) =>
        file.id === fileId
          ? {
              ...file,
              ...dataToUpdate,
              ...(file.duration || dataToUpdate.duration
                ? { audioDuration: determineAudioDuration({ ...file, ...dataToUpdate }) }
                : {}),
            }
          : file
      ) ?? [];

    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
          testFiles,
        },
      })
    );
  };

  const handleAddAnswerFile = (answerIndex, file, fileType) => {
    if (file.size > maxBytesFile) {
      notification.open({
        message: t('UPLOAD_FILE_ERROR'),
        type: 'error',
      });
    } else {
      const formattedFile = {
        ...file,
        id: v4(),
        fileType,
      };

      if (!newScreening?.currentQuestionData)
        newScreening.currentQuestionData = defaultCurrenQuestionData;

      if (!newScreening?.currentQuestionData?.options) {
        newScreening.currentQuestionData.options =
          newScreening?.currentTypeQuestion === AnswerTypeEnum.DRAW
            ? defaultDrawState
            : defaultCheckState;
      }

      if (newScreening?.currentQuestionData?.options[answerIndex]?.files?.length) {
        newScreening?.currentQuestionData?.options[answerIndex]?.files.push(formattedFile);
      } else {
        newScreening.currentQuestionData.options[answerIndex].files = [formattedFile];
      }

      dispatch(
        setNewScreeningData({
          ...newScreening,
          currentQuestionData: {
            ...newScreening?.currentQuestionData,
            options: newScreening?.currentQuestionData?.options ?? [],
          },
        })
      );
    }
  };

  const handleRemoveAnswerFile = (answerIndex, fileId) => {
    if (newScreening?.currentQuestionData?.options[answerIndex].files?.length === 1)
      newScreening.currentQuestionData.options[answerIndex].files =
        newScreening?.currentQuestionData?.options[answerIndex].files?.filter(
          (file) => file.id !== fileId
        );

    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening?.currentQuestionData,
          options: newScreening?.currentQuestionData?.options ?? [],
        },
      })
    );
  };

  const handleUpdateAnswerFile = (answerIndex, fileId, dataToUpdate) => {
    if (newScreening?.currentQuestionData?.options[answerIndex]?.files)
      newScreening.currentQuestionData.options[answerIndex].files =
        newScreening?.currentQuestionData?.options[answerIndex]?.files?.map((file) =>
          file.id === fileId ? { ...file, ...dataToUpdate } : file
        );

    dispatch(
      setNewScreeningData({
        ...newScreening,
        currentQuestionData: {
          ...newScreening.currentQuestionData,
        },
      })
    );
  };

  const handleGenerateAIAnswer = async (answer) => {
    setLoadingAIAnswer(true);
    const data = {
      question: newScreening?.currentQuestionData?.text,
      concepts: newScreening?.currentQuestionData?.concepts,
      promptSubType: newScreening?.currentQuestionData?.promptSubType,
      answer,
    };
    if (data?.promptSubType === PromptSubTypes.MECHANOGRAPHY_CORRECTION) {
      data.wordsPerMinute = MECHANOGRAFY_PPM_TEST;
    }
    const response = await getAIQuestionTrial(data)
      .catch(() =>
        notification.open({
          message: t('QUESTION_TEXT_TOGGLE_AI_ADD_TEST_ANSWER_ERROR'),
          type: 'error',
        })
      )
      .finally(() => setLoadingAIAnswer(false));
    return response;
  };

  const setEditNewScreeningByTestGroup = async ({
    customTestGroup = undefined,
    testGroupList = undefined,
    customChallengeTestGroup = undefined,
  }) => {
    const patchData = {
      allowCertificateDownload: evaluation.allowCertificateDownload ?? true,
      proctoringEnabled: evaluation.proctoringEnabled ?? true,
      requireCompletedProfile: evaluation.requireCompletedProfile ?? false,
      reviewType: evaluation.reviewType ?? ReviewTypeEnum.GLOBAL,
      reminderToCandidates: evaluation.reminderToCandidates ?? true,
      searchTypes: evaluation.searchTypes ?? [],
      language: evaluation.language ?? 'es', // handle case for old draft without language
    };
    if (customTestGroup) {
      patchData.customTestGroup = {
        weight: customTestGroup?.weight,
        order: customTestGroup?.order,
        duration: customScreeningTotalTime,
        tests: newScreening?.customTestGroup,
        hasSkipQuestion: customTestGroup?.hasSkipQuestion ?? true,
        screeningSortStrategy: getTestGroupScreeningStrategy(customTestGroupStrategy),
        ...(customTestGroupStrategy === StrategyValues.AI_INTERVIEW
          ? {
              recordingConfig: recordingConfig?.mode
                ? recordingConfig
                : { mode: RecordingMode.AUDIO_ONLY },
            }
          : {}),
        type: TestGroupTypes.CUSTOM,
      };
    }
    if (customChallengeTestGroup) {
      const tests = newScreening?.customChallengeTestGroup;
      await uploadAndUpdateFiles(tests);
      patchData.customChallengeTestGroup = {
        weight: customChallengeTestGroup?.weight,
        order: customChallengeTestGroup?.order,
        duration: 1,
        tests,
        hasSkipQuestion: false,
        withoutTime: true,
        type: TestGroupTypes.CHALLENGE_ASYNC_AI,
      };
    }
    if (testGroupList) {
      patchData.testGroupList = testGroupList;
    }

    await editRecruitSessionDraft(queryData?.draftId, patchData).then(() => {
      notification.open({
        message: t('CREATE_EVALUATION_DRAFT_EDITED_NOTIFICATION'),
        type: 'success',
      });
    });
  };

  const handleEditTestGroupItem = ({ newTestGroupItem }) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        allTests: newScreening?.allTests?.map((item) =>
          item?.id === newTestGroupItem?.id ? { ...item, ...newTestGroupItem } : item
        ),
        testGroups: newScreening?.testGroups?.map((item) =>
          item?.id === newTestGroupItem?.id ? { ...item, ...newTestGroupItem } : item
        ),
      })
    );

    const testGroupList = newScreening?.allTests
      ?.filter(
        (item) =>
          item.type !== TestGroupTypes.CUSTOM && item.type !== TestGroupTypes.CHALLENGE_ASYNC_AI
      )
      .map((item) => (item.id === newTestGroupItem.id ? { ...item, ...newTestGroupItem } : item));
    setEditNewScreeningByTestGroup({ testGroupList });
  };

  const handleEditCustomTestGroupItem = async ({ newCustomTestGroupItem }) => {
    dispatch(
      setNewScreeningData({
        ...newScreening,
        allTests: newScreening?.allTests?.map((item) =>
          item.type === TestGroupTypes.CUSTOM ? { ...item, ...newCustomTestGroupItem } : item
        ),
        customTestGroup: newScreening?.customTestGroup?.map((item) =>
          item.type === TestGroupTypes.CUSTOM ? { ...item, ...newCustomTestGroupItem } : item
        ),
        customTestGrouphasSkipQuestion: newCustomTestGroupItem?.hasSkipQuestion,
      })
    );
    const customTestGroup = newScreening?.allTests?.find(
      (item) => item.type === TestGroupTypes.CUSTOM
    );
    customTestGroup.hasSkipQuestion = newCustomTestGroupItem?.hasSkipQuestion;
    const customChallengeTestGroup = newScreening?.allTests?.find(
      (item) => item.type === TestGroupTypes.CHALLENGE_ASYNC_AI
    );
    setEditNewScreeningByTestGroup({ customTestGroup, customChallengeTestGroup });
  };

  const handleCustomTestGroupStrategy = (strategy) => {
    dispatch(setCustomTestGroupStrategy(getCustomTestGroupScreeningStrategy(strategy)));

    // Update recordingConfig based on strategy
    const customTestGroup = newScreening?.allTests?.find(
      (item) => item.type === TestGroupTypes.CUSTOM
    );

    if (customTestGroup) {
      const updatedTestGroup = { ...customTestGroup };

      if (strategy === StrategyValues.AI_INTERVIEW) {
        // Set default recordingConfig if switching to AI_INTERVIEW
        updatedTestGroup.recordingConfig = recordingConfig?.mode
          ? recordingConfig
          : { mode: RecordingMode.AUDIO_ONLY };
        dispatch(setRecordingConfig(updatedTestGroup.recordingConfig));
      } else {
        // Remove recordingConfig if switching away from AI_INTERVIEW
        delete updatedTestGroup.recordingConfig;
      }

      dispatch(
        setNewScreeningData({
          ...newScreening,
          allTests: newScreening?.allTests?.map((item) =>
            item.type === TestGroupTypes.CUSTOM ? updatedTestGroup : item
          ),
        })
      );
    }
  };

  const handleRecordingConfig = (config) => {
    dispatch(setRecordingConfig(config));

    // Also update the recordingConfig in the custom test group in allTests
    const customTestGroup = newScreening?.allTests?.find(
      (item) => item.type === TestGroupTypes.CUSTOM
    );

    if (customTestGroup && customTestGroupStrategy === StrategyValues.AI_INTERVIEW) {
      dispatch(
        setNewScreeningData({
          ...newScreening,
          allTests: newScreening?.allTests?.map((item) =>
            item.type === TestGroupTypes.CUSTOM ? { ...item, recordingConfig: config } : item
          ),
        })
      );
    }
  };

  return {
    handleNextStep,
    fetchNextPage,
    handleCurrentTypeQuestion,
    handleInput,
    modalTestSuggestionAI,
    handleSetModalTestSuggestionAI,
    handleSubmit,
    handlePreviousStep,
    handleScreeningName,
    handleSelectFilterOption,
    handleSelectFilterOptionMultiple,
    handleClearFilters,
    handleOrder,
    handleCustomTestGroupTime,
    handleCustomScreeningsTime,
    handleAddQuestion,
    handleAddSuggestionData,
    handleSetNewScreeningSuggestion,
    handleEditQuestion,
    handleAddFileTypes,
    handleAddQuestionText,
    handleAddQuestionDifficulty,
    resetCheckWeight,
    handleRemoveTestImage,
    handleAddAnswers,
    handleDelete,
    setEditData,
    handleTests,
    handleDeleteCustomTestGroup,
    handleDeleteChallengeTestGroup,
    modifyTestWeight,
    goToFirstStep,
    fetchLevels,
    setLoading,
    fetchCategories,
    formatCustomTestGroupToPost,
    formatChallengeTestGroupToPost,
    setLastNameFetched,
    handleAddTestFile,
    handleRemoveTestAudio,
    handleRemoveTestFile,
    toggleInfinitePlay,
    handleAddNumberOfPlays,
    handleUpdateTestFile,
    handleAddAnswerFile,
    handleRemoveAnswerFile,
    handleUpdateAnswerFile,
    handleGenerateAIAnswer,
    handleEditTestGroupItem,
    handleEditCustomTestGroupItem,
    setTestAnswer,
    testAnswer,
    loadingAIAnswer,
    disableWithoutWeight,
    disableAddCheckQuestion,
    disableAddFileQuestion,
    disableAddTextIaQuestion,
    disableQuestionButton: Boolean(
      !newScreening?.currentQuestionData?.text?.length ||
        disableAddTextQuestion ||
        disableAddFileQuestion ||
        disableAddCheckQuestion ||
        disableAddVideoAIQuestion
    ),
    disableAddTextQuestion,
    disableAddCodeQuestion,
    disableAddVideoAIQuestion,
    defaultCheckState,
    allTests: newScreening?.allTests,
    step: newScreening.step,
    testArray: testGroups,
    loading,
    fileTypes,
    testGroupLevelsFilterOptions,
    testGroupCategoriesFilterOptions,
    testGroupRolesFilterOptions,
    testGroupTagsFilterOptions,
    endorsementCreatorsOptions,
    endorsementCompaniesOptions,
    testGroupQuickRolesOptions,
    customTestGroupTotalTime,
    customScreeningTotalTime,
    testsDuration,
    newScreening,
    isEdit: newScreening?.isEdit,
    eachScore: newScreening?.eachScore,
    setEachScore,
    currentQuestionData: newScreening?.currentQuestionData,
    newScreeningFilters,
    currentTypeQuestion: newScreening.currentTypeQuestion,
    availableWeight: localAvailableWeight,
    preventReloadCondition,
    amountOfFilters,
    incompleteQuestionValidation,
    incompleteQuestion: customTestGroupIncompleteQuestion,
    incompletePrefilterQuestionValidation,
    welcomeVideos,
    formatFilters,
    fetchRoles,
    fetchRolesWithTestGroups,
    fetchTags,
    fetchEndorsementCreators,
    fetchEndorsementCompanies,
    fetchQuickRolesWithTestGroups,
    lastNameFetched,
    deselectTg,
    handleCurrentQuestionDataTime,
    handleCurrentQuestionDataTimeDuration,
    handleAddQuestionWrite,
    handleAddQuestionDraw,
    handleAddQuestionChallengeAsync,
    disableAddWriteQuestion,
    disableAddChallengeAsyncQuestion,
    handleToggleIsTyping,
    handleAddQuestionLanguage,
    defaultCodeOutputState,
    handleAddCodeAnswers,
    fetchPrefilterQuestions,
    searchPrefilterQuestionsText,
    handleAddPrefilterQuestion,
    handleRemovePrefilterQuestion,
    handleOrderByIndex,
    handleAddPrefilterResponseDelay,
    handleEditPrefilterQuestion,
    handleEditPrefilterTestQuestion,
    handleDeletePrefilterQuestion,
    handleDeletePrefilterTest,
    fetchAdditionalQuestions,
    searchAdditionalQuestionsText,
    handleDeleteAdditionalQuestion,
    handleEditAdditionalTestQuestion,
    fetchWelcomeVideos,
    addCustomWelcomeVideo,
    handleAddVideoInfo,
    deleteCustomWelcomeVideo,
    handleSelectLangCodesAIOption,
    handleInitialSetUpLangCodesAIOptions,
    handleLangCodesAIRubrics,
    removeLangCodeProperties,
    handleAddQuestionWeight,
    fetchPromptCorrectionTextAI,
    promptsCorrectionTextAI,
    handleAddPrompTextAI,
    handleAddPromptChallengeAI,
    handleAddQuestionExplanation,
    handleAddQuestionSubskills,
    determineAudioDuration,
    customTestGroupStrategy,
    handleCustomTestGroupStrategy,
    recordingConfig,
    handleRecordingConfig,
    addChallengeQuestionsToTestGroup,
    handleAddTestRubrics,
    handleInitialSetUpTestChallengeAI,
    handleAddQuestionDuration,
    handleAddQuestionType,
    handleAddBloomTaxonomy,
  };
};

export default useCreateScreening;
